import React from 'react';
import { CHECKOUT_URL } from '../data/content';
type CtaButtonProps = {
  label: string;
  subline?: string;
  variant?: 'red' | 'light';
  className?: string;
};
export function CtaButton({
  label,
  subline,
  variant = 'red',
  className = ''
}: CtaButtonProps) {
  const base = 'group inline-flex w-full max-w-md items-center justify-center gap-2 rounded-xl px-5 py-4 text-center text-[15px] font-extrabold uppercase leading-tight tracking-wide transition-[transform,background-color,box-shadow] duration-200 ease-out active:scale-[0.98] sm:text-base';
  const styles = variant === 'red' ? 'bg-blood text-white shadow-cta hover:bg-bloodDark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blood' : 'bg-white text-ink shadow-card hover:bg-cream focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white';
  return <div className={`flex w-full flex-col items-center ${className}`} data-id="element-27" data-mp="15b19qh8py8yl">
      <a href={CHECKOUT_URL} className={`${base} ${styles}`} data-cta="checkout" data-id="element-28" data-mp="35xxp4gty87oj">
        <span aria-hidden="true" className="text-lg leading-none" data-id="element-29" data-mp="39zj01wmxabw3">
          🔴
        </span>
        <span data-id="element-30" data-mp="3ewja0imw7ysh">{label}</span>
      </a>
      {subline ? <p className={`mt-3 max-w-md text-center text-[11px] font-medium leading-relaxed sm:text-xs ${variant === 'red' ? 'text-graphite/70' : 'text-white/70'}`} data-id="element-31" data-mp="3jx76hjtw57u3">
          {subline}
        </p> : null}
    </div>;
}